import { NodeBaseDto, BasicNodeDto, LayersNodeDto, LayersWithSectionsNodeDto, SectionsNodeDto } from '../types';
import {
    BasicNodeModel,
    LayersNodeModel,
    LayersWithSectionsNodeModel,
    SectionsNodeModel,
    NodeBaseModel
} from '../models';
import { SourceModelBase } from '../../custom_shared/models';

export default class NodeFactory {
    static createOrUpdateNodes(data: NodeBaseDto[], existingNodes: NodeBaseModel[], sources: SourceModelBase[]) {
        return data.map(nodeDto => {
            const existingNode = existingNodes.find(t => t.id === nodeDto.id);

            if (existingNode) {
                existingNode.update(nodeDto, sources);

                existingNode.setChildNodes(
                    nodeDto.childNodes.length
                        ? [...NodeFactory.createOrUpdateNodes(nodeDto.childNodes, existingNode.childNodes, sources)]
                        : []
                );

                return existingNode;
            }

            const newNode = NodeFactory.createNode(nodeDto, sources);

            if (nodeDto.childNodes.length) {
                newNode.setChildNodes([...NodeFactory.createOrUpdateNodes(nodeDto.childNodes, [], sources)]);
            }

            return newNode;
        });
    }

    static createNode(data: NodeBaseDto, sources: SourceModelBase[]) {
        switch (data.type) {
            case 'Basic':
                return new BasicNodeModel(data as BasicNodeDto, sources);
            case 'Layers':
                return new LayersNodeModel(data as LayersNodeDto, sources);
            case 'LayersWithSections':
                return new LayersWithSectionsNodeModel(data as LayersWithSectionsNodeDto, sources);
            case 'Sections':
                return new SectionsNodeModel(data as SectionsNodeDto, sources);
            default:
                throw new Error('Unsupported node type');
        }
    }
}
